import { useMemo } from "react";
import { queriesInternalAccounts } from "@query";

/**
 * Whether the entity change has to be verified at the Banking level rather than
 * Tax.
 *
 * v1 also answered true for a user carrying a payer context or an enterprise
 * account type. Neither has a v3 equivalent — the enterprise account type is not
 * coming, and the payer context is dropped for now — so the wallet account is the
 * only remaining signal: a payer-context payee with no internal account now
 * verifies at Tax level where it used to verify at Banking.
 */
export const useRequiresBankingVerification = (): boolean => {
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();

  return useMemo(
    () =>
      !!queryInternalAccounts.data?.data?.some(
        account => account.status === "Active" || account.status === "Pending"
      ),
    [queryInternalAccounts.data]
  );
};
